export enum PatientStationType {
    Table = 1,
    Card = 2,
}
